// Utility functions for handling redirects

import { BASE_API_URL } from 'consts/appConsts';

import { clearLocalData } from 'utils/storage/storageHelper';

export default function doRedirect(
  url,
  { navigateToLegacyApp, clearData, clearAnonymousId }
) {
  if (clearData) {
    clearLocalData(clearAnonymousId);
  }

  if (navigateToLegacyApp) {
    const divider = url?.startsWith?.('/') ? '' : '/';
    // Using window.location here, to prevent SAME ORIGIN issues
    window.location = `${BASE_API_URL}${divider}${url}`;
  } else {
    window.location.href = url;
  }
}
